<template>
  <div class="pt-3 px-3 mb-3 light-gray-container">
    <TitleBreadCrumb
      class="return-to-school-title"
      :has-route="false"
      :page="{
        icon: 'fas fa-flag',
        title: 'Recomendado',
      }"
    />

    <ValidationObserver ref="form" tag="div" class="row px-4 pb-4">
      <div class="col-12 col-md-3 pt-2">
        <ValidationProvider
          v-slot="{ errors }"
          name="Recomendado por"
          rules="required"
          :custom-messages="{
            required: 'Favor seleccione el tipo de recomendación.',
          }"
        >
          <CustomDropDown
            v-model="model.recommendationType"
            :options="collections.recommendationTypes"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            placeholder="Seleccione"
            fieldkey="id"
            fieldname="name"
            label="Recomendado por:"
            :disabled="readonly"
          />
        </ValidationProvider>
      </div>

      <div class="col-12 col-md-3 pt-2">
        <ValidationProvider
          v-slot="{ errors }"
          rules="required|checkAuthNumber"
          :custom-messages="{
            required: 'Favor escriba número de autorización.',
          }"
        >
          <CustomInput
            v-model="model.authNumber"
            label="Número de Autorización:"
            regular-label
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            :disabled="readonly"
            class="read-only"
          />
        </ValidationProvider>
      </div>

      <div class="col-12 col-md-3 pt-2">
        <ValidationProvider
          v-slot="{ errors }"
          name="Jornada diaria"
          rules="required"
          :custom-messages="{
            required: 'Favor seleccione jornada diaria.',
          }"
        >
          <CustomDropDown
            v-model="model.dailyShift"
            :options="collections.dailyShifts"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            placeholder="Seleccione"
            fieldkey="id"
            fieldname="name"
            label="Jornada diaria:"
            :disabled="readonly"
          />
        </ValidationProvider>
      </div>

      <div v-if="!readonly" class="col-12 col-md-3 mt-auto text-right">
        <ActionButton
          class="m-1"
          text="Cancelar"
          variant="outline-danger"
          i="fas fa-times-circle"
          @click="onCancel"
        />
        <ActionButton
          v-if="!readonly"
          class="m-1"
          text="Continuar"
          variant="success"
          i="fas fa-arrow-alt-circle-right"
          @click="onContinue"
        />
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { extend } from 'vee-validate';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import TitleBreadCrumb from 'TitleBreadCrumb';
import alert from '@/mixin/alert.mixin';
import CustomDropDown from 'custom-drop-down';
import {
  checkAuthNumber,
  getRecommendedInformation,
} from '@/modules/human-resources/api';

// Extended rules
extend('checkAuthNumber', {
  async validate(value) {
    const exists = await checkAuthNumber(value);
    return !exists;
  },
  message: 'El número de autorización ya existe.',
});

const initialModel = () => ({
  authNumber: null,
  dailyShift: null,
  recommendationType: null,
});

export default {
  name: 'RecommendedInformation',
  mixins: [alert],
  components: {
    CustomInput,
    ActionButton,
    TitleBreadCrumb,
    CustomDropDown,
  },
  props: {
    currentStatus: {
      type: Number,
      default: 0,
    },
    currentStatusTarget: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    collections: {
      type: Object,
      required: true,
    },
  },
  data: () => ({ model: initialModel() }),
  methods: {
    async onContinue() {
      if (this.readonly) return;

      const valid = await this.$refs['form'].validate();
      if (valid) {
        const model = {
          currentStatusTargetId: this.currentStatusTarget.id,
          authNumber: this.model.authNumber,
          dailyShift: this.model.dailyShift,
          recommendationType: this.model.recommendationType,
        };
        this.$emit('continue', model);
      } else {
        this.ShowToast(
          'Información Incompleta',
          'Favor de completar la información solicitada.',
          'error'
        );
      }
    },
    onCancel() {
      this.model = initialModel();
      this.$refs['form'].reset();
      this.$emit('cancel');
    },
  },
  async mounted() {
    if (this.$route.params.id) {
      const id = this.$route.params.id;
      const data = await getRecommendedInformation(id);

      this.model.authNumber = data.authorizationNumber;
      this.model.dailyShift = this.collections.dailyShifts.find(
        (x) => x.id === data.dailyShiftId
      );
      this.model.recommendationType = this.collections.recommendationTypes.find(
        (x) => x.id === data.recommendationTypeId
      );
    }
  },
};
</script>

<style scoped>
.light-gray-container {
  background: #f7f7f7;
  border-radius: 5px;
  border-left: 6px solid #2db782;
}

::v-deep .fas.fa-flag {
  font-size: 16px;
  color: #2db782;
}

::v-deep .dot {
  padding: 0 !important;
}

::v-deep .tag-badge {
  background: none !important;
}

::v-deep .tag-badge-title {
  font-size: 16px !important;
}
</style>
